import React from "react";
import styled, { css } from "styled-components";

// type Props = {
//   id?: string;
//   className?: string;
//   style?: any;
//   align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
//   color?:
//     | 'black'
//     | 'darkGrey'
//     | 'medGrey'
//     | 'lightGrey'
//     | 'success'
//     | 'error'
//     | 'link'
//     | 'disabled'
//     | 'inherit'
//     | 'initial'
//     | 'unset';
//   component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
//   gutterBottom?: boolean;
//   variant?:
//     | 'h1'
//     | 'h2'
//     | 'h3'
//     | 'h4'
//     | 'h5'
//     | 'body'
//     | 'bodyBold'
//     | 'caption'
//     | 'captionBold';
// };

const Typography = ({
  children,
  id,
  className,
  style,
  align = "inherit",
  color = "black",
  component = "p",
  gutterBottom,
  variant = "body"
}) => {
  const props = { id, className, style, align, color, gutterBottom, variant };

  switch (component) {
    case "h1":
      return <StyledH1 {...props}>{children}</StyledH1>;
    case "h2":
      return <StyledH2 {...props}>{children}</StyledH2>;
    case "h3":
      return <StyledH3 {...props}>{children}</StyledH3>;
    case "h4":
      return <StyledH4 {...props}>{children}</StyledH4>;
    case "h5":
      return <StyledH5 {...props}>{children}</StyledH5>;
    case "h6":
      return <StyledH6 {...props}>{children}</StyledH6>;
    case "p":
    default:
      return <StyledP {...props}>{children}</StyledP>;
    case "span":
      return <StyledSpan {...props}>{children}</StyledSpan>;
  }
};

const typographyStyles = {
  color: {
    white: '#FFFFFF',
    black: '#0A1F44',
    darkGrey: '#364866',
    medGrey: '#53627C',
    lightGrey: '#8A94A6',
    success: '#1F8651',
    error: '#C7053F',
    link: '#0F9BF0',
    disabled: '#C9CED6'
  },
  fontSize: {
    h1: '24px',
    h2: '20px',
    h3: '18px',
    h4: '16px',
    h5: '16px',
    body: '14px',
    bodyBold: '14px',
    caption: '12px',
    captionBold: '12px'
  },
  fontWeight: {
    h1: 'bold',
    h2: 'bold',
    h3: 'bold',
    h4: 'normal',
    h5: 'bold',
    body: 'normal',
    bodyBold: 'bold',
    caption: 'normal',
    captionBold: 'bold'
  },
  lineHeight: {
    h1: '36px',
    h2: '30px',
    h3: '24px',
    h4: '22px',
    h5: '22px',
    body: '24px',
    bodyBold: '24px',
    caption: '18px',
    captionBold: '18px'
  }
};

const baseStyles = css`
  margin: 0;
  font-family: "Open Sans", sans-serif;
`;

const StyledTypography = styled.p`
  ${baseStyles}

  ${(p) =>
    ["inherit", "initial", "unset"].includes(p.color)
      ? css`
          color: ${p.color};
        `
      : css`
          color: ${(p) => typographyStyles.color[p.color]};
        `}

  ${(p) =>
    p.gutterBottom &&
    css`
      margin-bottom: 0.35em;
    `}

  font-size: ${(p) => typographyStyles.fontSize[p.variant]};
  font-weight: ${(p) => typographyStyles.fontWeight[p.variant]};
  line-height: ${(p) => typographyStyles.lineHeight[p.variant]};

  text-align: ${(p) => p.align};
`;

const StyledH1 = StyledTypography.withComponent("h1");

const StyledH2 = StyledTypography.withComponent("h2");

const StyledH3 = StyledTypography.withComponent("h3");

const StyledH4 = StyledTypography.withComponent("h4");

const StyledH5 = StyledTypography.withComponent("h5");

const StyledH6 = StyledTypography.withComponent("h6");

const StyledP = StyledTypography;

const StyledSpan = StyledTypography.withComponent("span");

export default Typography;
